module.exports = __webpack_public_path__ + "static/media/blackboard.233681a4.png";